import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutMainDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutMainDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutMainDeleteRequest) {
    JsonSchemaValidator.assert(
      RoomStageLayoutMainDeleteRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomStageLayoutMainDeleteRequest {
  roomId: RoomId;
}
